/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

/**
 The boxShadow() function helps you to create a box shadow for an element
 */

// Material Dashboard 2 React helper functions
import rgba from 'assets/theme/functions/rgba';
import pxToRem from 'assets/theme/functions/pxToRem';
import colors from 'assets/theme-dark/base/colors';

const { black, grey } = colors;

function boxShadow(offset = [], radius = [], color = black.main, opacity = 0.12, inset = '') {
  const [x, y] = offset;
  const [blur, spread] = radius;

  return `${inset} ${pxToRem(x)} ${pxToRem(y)} ${pxToRem(blur)} ${pxToRem(spread)} ${rgba(
    color,
    opacity
  )}`;
}

export default boxShadow;

export function selectedIcon(selectedColor, darkMode) {
  return darkMode
    ? `${boxShadow([0, 0], [0, 3], grey[500], 0.75)}`
    : `${boxShadow([0, 0], [0, 2], selectedColor, 0.35)}`;
}
